/* istanbul ignore file */
import React from 'react';

import { MenuSection } from '@lumapps/lumx-menu/components/Menu/MenuSection';
import { MenuItemsSkeleton } from '@lumapps/lumx-menu/components/Menu/Skeleton/MenuItemsSkeleton';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { Suspense } from '@lumapps/utils/components/Suspense';

import { SettingsMenuCommunitiesProps } from './SettingsMenuCommunities';

const LazySettingsMenuCommunities = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'settings-menu-communities' */
        './SettingsMenuCommunities'
    );

    return { default: resolved.SettingsMenuCommunities };
});

const SettingsMenuCommunities = (props: SettingsMenuCommunitiesProps) => {
    const { translateKey } = useTranslate();

    return (
        <Suspense
            loadingFallback={
                <MenuSection label={translateKey(GLOBAL.COMMUNITY)}>
                    <MenuItemsSkeleton hasIcon itemCount={3} loadingMessage={translateKey(GLOBAL.LOADING)} />
                </MenuSection>
            }
        >
            <LazySettingsMenuCommunities {...props} />
        </Suspense>
    );
};

export { SettingsMenuCommunities };
